import axios from 'axios'
import { Message } from 'element-ui'

export let isRelogin = { show: false };
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/java-backend/',
    timeout: 100000
});
service.interceptors.request.use(config => {
    const token = localStorage.getItem("cf40-token");
    const isToken = (config.headers || {}).isToken === false;
    if (token && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
}, error => {
    return Promise.reject(error)
});
service.interceptors.response.use(res => {
    const code = res.data.code || 200;
    const isPasswordLogin = (res.config.url || "").split("?")[0] === "/pc/api/login";
    const msg = res.data.msg;
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
        return res.data
    }
    if (isPasswordLogin && code !== 200) {
        Message({ message: msg || "登录失败 / Login failed", type: "error" });
    } else if (code === 500) {
        Message({ message: msg, type: 'error' })
    } else if (code === 601) {
        Message({ message: msg, type: 'warning' })
    } else if (code !== 200 && code !== 2005 && code !== 2003) {
      Message({ message: msg, type: "error" });
    }
    return res.data
},
error => {
    let { message, response } = error;
    // PDF 下载由页面解析错误 Blob 并关闭下载状态，避免保存错误文件或重复提示。
    if (error.config && error.config.responseType === 'blob'
        && (error.config.url || '').includes('/product/privatePreView')) {
        return response ? response.data : Promise.reject(error);
    }
    if (response && response.status === 401) {
        message = response.data.msg;
        if (!isRelogin.show) {
            isRelogin.show = false;
            localStorage.clear();
        }
    } else if (response && response.data && response.data.msg) {
        message = response.data.msg;
    } else if (message == "Network Error") {
        message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return response ? response.data : Promise.reject(error);
});
export default service;
